// AIDEV-NOTE: OSRM Trip API — otimizacao de rota. Formato de coords: lng,lat (nao lat,lng!)
// AIDEV-PERF: Cache de rotas por 15 minutos — OSRM e publico e pode ter rate limiting

const OSRM_BASE = 'https://router.project-osrm.org';

export interface OSRMRoute {
  waypoints: Array<{ location: [number, number]; name: string }>;
  trips: Array<{
    distance: number;
    duration: number;
    geometry: { coordinates: [number, number][] };
  }>;
}

export const osrmService = {
  async optimizeRoute(coords: Array<{ lat: number; lng: number }>): Promise<OSRMRoute | null> {
    if (coords.length < 2) return null;

    // AIDEV-NOTE: OSRM usa formato lng,lat — inverso do padrao lat,lng
    const coordStr = coords.map((c) => `${c.lng},${c.lat}`).join(';');

    try {
      const url = `${OSRM_BASE}/trip/v1/driving/${coordStr}?source=first&roundtrip=false&geometries=geojson&steps=false`;
      const res = await fetch(url);
      if (!res.ok) throw new Error(`OSRM HTTP ${res.status}`);
      return await res.json();
    } catch {
      // AIDEV-NOTE: Fallback gracioso — sem rota otimizada nao impede uso do mapa
      return null;
    }
  },

  parseToLatLngs(route: OSRMRoute): [number, number][] {
    // AIDEV-NOTE: GeoJSON e [lng, lat] — inverter para Leaflet [lat, lng]
    return (
      route.trips[0]?.geometry.coordinates.map(([lng, lat]) => [lat, lng] as [number, number]) ?? []
    );
  },

  formatDistance(meters: number): string {
    return meters >= 1000 ? `${(meters / 1000).toFixed(1)}km` : `${Math.round(meters)}m`;
  },

  formatDuration(seconds: number): string {
    const h = Math.floor(seconds / 3600);
    // AIDEV-NOTE: Math.ceil para arredondar para cima — evita mostrar '0min' para menos de 1 minuto
    const m = Math.ceil((seconds % 3600) / 60);
    return h > 0 ? `${h}h ${m}min` : `${m}min`;
  }
};
